module.exports = __webpack_public_path__ + "static/media/13.dbfc811d.png";